import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Alerts from './pages/Alerts'
import Integrations from './pages/Integrations'
import Inventory from './pages/Inventory'
import InventoryOverview from './pages/InventoryOverview'
import Dossiers from './pages/Dossiers'
import DossierDetail from './pages/DossierDetail'
import Scans from './pages/Scans'
import Settings from './pages/Settings'
import System from './pages/System'
import NotFound from './pages/NotFound'
import { SeoPlanPage } from './modules/seo-plan'

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/inventory" element={<InventoryOverview />} />
                <Route path="/inventory/:targetId" element={<Inventory />} />
                {/* Platformen merged into Dossiers (migration 063). */}
                <Route path="/targets" element={<Navigate to="/dossiers" replace />} />
                <Route path="/alerts" element={<Alerts />} />
                {/* Historic entry points into the scan pages, kept so bookmarks
                    and older links keep working. */}
                <Route path="/scan-center" element={<Navigate to="/scans" replace />} />
                <Route path="/seo" element={<SeoPlanPage />} />
                <Route path="/security" element={<Navigate to="/scans" replace />} />
                <Route path="/tasks" element={<Navigate to="/scans" replace />} />
                <Route path="/dossiers" element={<Dossiers />} />
                <Route path="/dossiers/:id" element={<DossierDetail />} />
                <Route path="/scans" element={<Scans />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/system" element={<System />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default App
